import { Divider, PageHeader, Tabs } from "antd";
import LayoutCss from "layout/layout.module.scss";
import K from "utilities/constants";
import { pick } from "lodash";
import { useQueryState } from "../../../hooks/useQueryState";
import { UsersContainer } from "./usersContainer";
import { ClientSideDataGrid } from "../../../common/components/clientSideDataGrid/clientSideDataGrid";

const TabsConfig = {
  source2: {
    key: "source2",
    label: "Source2",
    userType: K.Users.Type.Source2,
    renderComponent: (props) => <ClientSideDataGrid key="source2" {...props} />,
  },
  external: {
    key: "external",
    label: "External",
    userType: K.Users.Type.External,
    renderComponent: (props) => (
      <ClientSideDataGrid key="external" {...props} />
    ),
  },
};

export default function Users() {
  const [tab, setTab] = useQueryState("tab", TabsConfig.source2.key);

  const activeTab = TabsConfig[tab];

  const tabItems = Object.values(TabsConfig).map((t) =>
    pick(t, ["key", "label"]),
  );

  return (
    <>
      <PageHeader
        ghost={false}
        title="Users"
        footer={
          <>
            <Divider className={LayoutCss.appPageHeaderDivider} />
            <Tabs
              activeKey={activeTab.key}
              onChange={setTab}
              className={LayoutCss.appPageHeaderTabs}
              items={tabItems}
            />
          </>
        }
        className={LayoutCss.appPageHeader}
      />

      <UsersContainer
        type={activeTab.userType}
        renderTable={activeTab.renderComponent}
      />
    </>
  );
}
